import React, { createContext, useState, useEffect, useContext } from "react";
import { auth, db } from "../firebase/firebase"; // Corrected path
import { doc, onSnapshot } from "firebase/firestore";
import { updateUserData, fetchUserData } from "../utils/userData"; // Corrected path

export const ImageButtonsContext = createContext({
  showImageButtons: false,
  setShowImageButtons: () => {}, // This will be the function that also persists to Firestore
});

export const ImageButtonsProvider = ({ children }) => {
  const [showImageButtons, setShowImageButtonsState] = useState(false); // Renamed state setter

  // Effect to fetch initial state from Firestore and listen for changes
  useEffect(() => {
    let unsubscribe = () => {};
    const currentUser = auth.currentUser;

    if (currentUser) {
      // Fetch initial value from localStorage for quick UI update
      const fromLS = localStorage.getItem(`showImageButtons_${currentUser.uid}`);
      if (fromLS !== null) {
        setShowImageButtonsState(JSON.parse(fromLS));
      }

      // Then fetch from Firestore to ensure consistency and get the latest value
      fetchUserData(currentUser.uid).then(userData => {
        if (userData && typeof userData.showImageButtons === 'boolean') {
          setShowImageButtonsState(userData.showImageButtons);
          // Update localStorage if Firestore had a different value
          if (JSON.parse(fromLS || "false") !== userData.showImageButtons) {
            localStorage.setItem(`showImageButtons_${currentUser.uid}`, JSON.stringify(userData.showImageButtons));
          }
        } else if (userData && typeof userData.showImageButtons === 'undefined') {
          // If the value doesn't exist in Firestore, set it based on current state (or default)
          // This helps in migrating users who didn't have this setting before
          updateUserData(currentUser.uid, { showImageButtons: showImageButtons });
        }
      });

      const userDocRef = doc(db, "users", currentUser.uid);
      unsubscribe = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (typeof data.showImageButtons === 'boolean') {
            setShowImageButtonsState(data.showImageButtons);
            localStorage.setItem(`showImageButtons_${currentUser.uid}`, JSON.stringify(data.showImageButtons));
          }
        }
      });
    }

    return () => unsubscribe();
  }, [auth.currentUser]); // Re-run when auth.currentUser changes

  // Function to update state and persist to Firestore
  const setShowImageButtons = async (value) => {
    const currentUser = auth.currentUser;
    setShowImageButtonsState(value); // Update local state immediately for responsiveness
    localStorage.setItem(`showImageButtons_${currentUser?.uid}`, JSON.stringify(value)); // Update LS

    if (currentUser) {
      try {
        await updateUserData(currentUser.uid, { showImageButtons: value });
      } catch (error) {
        console.error("Failed to update showImageButtons in Firestore:", error);
        // Optionally, revert state and LS if Firestore update fails
      }
    }
  };

  return (
    <ImageButtonsContext.Provider
      value={{ showImageButtons, setShowImageButtons }}
    >
      {children}
    </ImageButtonsContext.Provider>
  );
};
